<template>
  <a
    :href="adminUrl"
    :class="$style.base"
  >
    <BaseIcon
      :name="user.impersonated ? 'eye-off' : 'eye'"
      :color="
        user.impersonated ? 'error' : showMobileMenu ? 'inverted' : 'default'
      "
      :tooltip="{
        position: 'bottom',
        text: $t(user.impersonated ? 'nav.stop_impersonating' : 'nav.analyze')
      }"
      @click="() => {}"
    />
    <!-- The empty click handler is needed for hover styles to work -->
  </a>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import config from '@/config';
import { useCompanyStore } from '@/stores/company';
import { usePageLayoutStore } from '@/stores/page-layout';
import { useUserStore } from '@/stores/user';

export default defineComponent({
  setup() {
    return {
      backendUrl: config.backendUrl,
      analyzeUrl: config.analyzeUrl ?? config.backendUrl,
    };
  },
  computed: {
    ...mapState(useUserStore, ['user']),
    ...mapState(useCompanyStore, ['company']),
    ...mapState(usePageLayoutStore, ['showMobileMenu']),
    adminUrl() {
      if (this.user.impersonated) {
        // Stopping impersonation must happen on the domain that started it
        return `${this.backendUrl}/stop_impersonating`;
      } else if (this.user.treatwellAdmin) {
        return `${this.backendUrl}/treatwell_admin/company`;
      } else {
        return `${this.analyzeUrl}/analyze/companies`;
      }
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: center;
}
</style>
